import { FC, useEffect, useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Messages, CaseMessage, Message } from "../../../../../../../shared/chat/messages";
import { message } from "antd";
import { ComponentQueryLoader } from "../../../../../../../shared/component-query-loader";
import {
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Document,
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateDocument,
} from "../../../../../../../../generated";

interface CaseDetailsMessagesContainerProps {
  caseId: string;
}

interface FinanceDetailsTransactions {
  adhocTransactions?: Array<{
    reason?: string | null;
    amount?: number | null;
    createdAt?: any | null;
    transactionReference?: {
      referenceId?: string | null;
    } | null;
  } | null> | null;
}

export const CaseDetailsMessagesContainer: FC<CaseDetailsMessagesContainerProps> = (props) => {
  const [messages, setMessages] = useState<CaseMessage[]>();
  const [transactions, setTransactions] = useState<FinanceDetailsTransactions | null>();

  const {
    data: queryData,
    loading,
    error,
  } = useQuery(CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Document, {
    variables: {
      identityVerificationCaseV1Id: props.caseId,
    },
  });

    const { startPolling, stopPolling, data: pollingData } = useQuery(CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Document,
      {
        variables: {
          identityVerificationCaseV1Id: props.caseId,
        },
      }
    );

  const [updatedMessages] = useMutation(
    CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateDocument
  );

  useEffect(() => {
    if(queryData?.identityVerificationCaseV1){
      setTransactions(queryData?.identityVerificationCaseV1?.financeDetails?.transactions);
    }
    if (queryData?.identityVerificationCaseV1?.messages) {
      setMessages(queryData?.identityVerificationCaseV1?.messages.filter((message): message is CaseMessage => message !== null) ?? [])
    }
  }, [queryData]);

  const handleSave = async (values: any) => {
    try {
      const result = await updatedMessages({
        variables: {
          input: values,
        },
      });
      if (result.data?.identityVerificationCaseV1Update?.status.success) {
        if (
          result.data?.identityVerificationCaseV1Update
            .identityVerificationCaseV1
        ) {
          setMessages(
            (result.data?.identityVerificationCaseV1Update
              .identityVerificationCaseV1.messages?.filter((message): message is CaseMessage => message !== null) ?? [])
          );
        }
      } else {
        message.error(
          `Error in sending message: ${result.data?.identityVerificationCaseV1Update?.status.errorMessage}`
        );
      }
    } catch (error) {
      message.error(`Error in sending message: ${JSON.stringify(error)}`);
    }
  };

  const getData = async () => {
    console.log("data");
  };

  const reloadMessages = () => {
    getData();
  };

  const lastName =
    queryData?.identityVerificationCaseV1?.applicant?.personalInformation
      ?.identityDetails?.lastName ?? "";
  const restOfName =
    queryData?.identityVerificationCaseV1?.applicant?.personalInformation
      ?.identityDetails?.restOfName ?? "";

  return (
    <ComponentQueryLoader
      error={error}
      loading={loading}
      hasData={messages !== undefined}
      hasDataComponent={
        <Messages
          disabled={queryData?.identityVerificationCaseV1?.state === 'decisionRendered'}
          caseId={props.caseId}
          data={{
            messages: messages ?? [],
            applicant: { lastName: lastName, restOfName: restOfName },
          }}
          updateMessage={reloadMessages}
          onSave={handleSave}
          startPollingMessages={startPolling}
          pollingMessagesData={{ data: { id: pollingData?.identityVerificationCaseV1?.id, messages: pollingData?.identityVerificationCaseV1?.messages as Message[] } }}
          stopPollingMessages={stopPolling}
          transactions={transactions} 
          cyberSourcePublicKey={undefined} 
          applicantId={undefined}
          paymentInstrument={{
            billTo: undefined,
            cardNumber: undefined,
            cardType: undefined,
            expirationMonth: undefined,
            expirationYear: undefined,
            id: undefined,
            paymentInstrumentId: undefined,
            state: undefined
          }}
          country={[]}        />
      }
    />
  );
};
